import { authentication } from '@ecosystem/newron-client-lib';
import { getImpersonationHeader } from './impersonation';
import { BFF_HOST } from './constants';
import { Market } from '../context/types';

export interface AuthResult {
  product: string;
  internalProduct: string;
  approved: { cell: string }[];
}

export const fetchCollectionsRegistry = async (): Promise<any[]> => {
  const token = await authentication.getAccessToken();
  const impersonationHeader = getImpersonationHeader();
  const fullApiUrl = `${BFF_HOST}/collection/config`;

  const result = await fetch(fullApiUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...impersonationHeader,
    },
  });

  return (await result.json()) as AuthResult[];
};

export const fetchEntitledMarkets = async (proposition: string): Promise<Market[]> => {
  try {
    const token = await authentication.getAccessToken();
    const impersonationHeader = getImpersonationHeader();
    const fullApiUrl = `${BFF_HOST}/markets/${proposition}`;

    const result = await fetch(fullApiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...impersonationHeader,
      },
    });

    return await result.json();
  } catch (error) {
    console.error('Failed to fetch entitled markets:', error);
    throw error;
  }
};
